/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export  function validateArr (rules, value, callback) {
  if(Array.isArray(value) && value.length > 0) {
    callback()
  } else {
    callback(new Error('设备不能为空'))
  }
}

export function isNullArray(arg){
   if(arg === undefined || arg === null || arg.length <= 0 || arg[0] === ''){
     return true
   }else{
     return false
   }
}

export function isNullStr(arg){
  if(arg === undefined || arg === null || arg.length <= 0 || arg === ''){
    return true
  }else{
    return false
  }
}

const QUESTION_TEXT_VALIDATION_RULES = Object.freeze({
  1: {
    pattern: /^-?(?:\d+\.?\d*|\d*\.?\d+)$/,
    failTips: '请输入正确的数字'
  },
  2: {
    pattern: /^[\u2E80-\u9FFF]+$/,
    failTips: '请输入正确的汉字'
  },
  3: {
    pattern: /^(?:\+?[1-9]\d{6,14}|0\d{7,11}|1\d{10})$/,
    failTips: '手机号格式不正确'
  },
  4: {
    pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    failTips: '邮箱格式不正确'
  }
})

export function normalizeQuestionTextValue(value) {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value).trim()
}

export function getQuestionTextValidationRule(checkTextType) {
  return QUESTION_TEXT_VALIDATION_RULES[checkTextType] || null
}

export function isQuestionTextValid(checkTextType, inputValue) {
  const rule = getQuestionTextValidationRule(checkTextType)
  if (!rule) {
    return true
  }
  return rule.pattern.test(normalizeQuestionTextValue(inputValue))
}

export function getQuestionTextFailTips(checkTextType) {
  const rule = getQuestionTextValidationRule(checkTextType)
  return rule ? rule.failTips : ''
}

const REGEXP_LITERAL = /^\/([\s\S]+)\/([gimsuy]*)$/

/**
 * 将编辑页保存的正则字符串编译为 RegExp，不使用 eval。
 * 支持 `/pattern/flags` 与裸 pattern；非法表达式返回 null。
 */
export function compileQuestionRegPattern(pattern) {
  if (pattern instanceof RegExp) {
    return pattern
  }
  if (typeof pattern !== 'string') {
    return null
  }
  const trimmed = pattern.trim()
  if (!trimmed) {
    return null
  }
  let source = trimmed
  let flags = ''
  const literalMatch = trimmed.match(REGEXP_LITERAL)
  if (literalMatch) {
    source = literalMatch[1]
    flags = literalMatch[2] || ''
  }
  flags = flags.replace(/g/g, '')
  try {
    return new RegExp(source, flags)
  } catch (e) {
    return null
  }
}

export function hasQuestionRegRules(question) {
  const regList = question && question.__config__ && question.__config__.regList
  if (!Array.isArray(regList) || regList.length === 0) {
    return false
  }
  return regList.some((rule) => {
    if (!rule || rule.pattern === undefined || rule.pattern === null) {
      return false
    }
    if (rule.pattern instanceof RegExp) {
      return true
    }
    return typeof rule.pattern === 'string' && rule.pattern.trim() !== ''
  })
}

/**
 * 校验自定义正则。空值跳过（返回空字符串）；多条规则按顺序，返回第一条失败文案。
 */
export function getQuestionRegFailTips(question, inputValue) {
  const text = normalizeQuestionTextValue(inputValue)
  if (!text) {
    return ''
  }
  const regList = question && question.__config__ && question.__config__.regList
  if (!Array.isArray(regList) || regList.length === 0) {
    return ''
  }
  for (let index = 0; index < regList.length; index += 1) {
    const rule = regList[index]
    if (!rule || !rule.pattern) {
      continue
    }
    const regex = compileQuestionRegPattern(rule.pattern)
    if (!regex) {
      continue
    }
    regex.lastIndex = 0
    if (!regex.test(text)) {
      return rule.message || '格式不正确'
    }
  }
  return ''
}
